import React, { useRef, useState } from 'react';
import { CaptureOverlay } from '../shared';

interface ScreenPreviewProps {
  taskName: string;
  videoUrl: string | null;
  duration: number;
  isLandscape: boolean;
  onRetake: () => void;
  onUseRecording: () => void;
  onClose: () => void;
}

function formatTime(seconds: number): string {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export const ScreenPreview: React.FC<ScreenPreviewProps> = ({
  taskName,
  videoUrl,
  duration,
  isLandscape,
  onRetake,
  onUseRecording,
  onClose,
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (!videoRef.current || !videoUrl) return;
    if (isPlaying) {
      videoRef.current.pause();
    } else {
      videoRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <CaptureOverlay taskName={taskName} onClose={onClose}>
      <div className={isLandscape ? 'sc-landscape' : undefined}>
        <div className="sc-preview-body" onClick={togglePlay}>
          {videoUrl && (
            <video
              ref={videoRef}
              src={videoUrl}
              onEnded={() => setIsPlaying(false)}
            />
          )}
          <div className="sc-duration-badge">{formatTime(duration)} captured</div>
        </div>

        <div className="sc-action-bar">
          <button className="sc-btn-retake" onClick={onRetake}>↩ Retake</button>
          <button className="sc-btn-use" onClick={onUseRecording}>Use Recording</button>
        </div>
      </div>
    </CaptureOverlay>
  );
};
